import React from 'react';
import { Space } from 'antd';
import styled from 'styled-components';

import Card from 'components/molecules/card';

const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TopRightPart = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;

const BottomRightPart = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
`;

interface Props {
  title: string;
  firstPart: React.ReactNode;
  secondPart?: React.ReactNode;
  thirdPart?: React.ReactNode;
  rightPart?: React.ReactNode;
  topRightPart?: React.ReactNode;
  bottomRightPart?: React.ReactNode;
  errorPart?: React.ReactNode;
}

const FiltersCard: React.FC<Props> = ({
  title,
  firstPart,
  secondPart,
  thirdPart,
  rightPart,
  topRightPart,
  bottomRightPart,
  errorPart,
}) => {
  return (
    <Card title={title} error={errorPart} full>
      <MainWrapper>
        <Space direction="vertical" size="middle" align="start">
          <Space direction="horizontal" size="middle" align="center" wrap>
            {firstPart}
          </Space>
          <Space direction="horizontal" size="middle">
            {secondPart}
          </Space>
          <Space direction="horizontal" size="middle">
            {thirdPart}
          </Space>
        </Space>
        <Space direction="vertical" align="center" size="small" style={{ paddingLeft: 32, width: 250 }}>
          {rightPart}
        </Space>
      </MainWrapper>
      <TopRightPart>{topRightPart}</TopRightPart>
      <BottomRightPart>{bottomRightPart}</BottomRightPart>
    </Card>
  );
};

export default FiltersCard;
